import React from 'react';
import PropTypes from 'prop-types';
import { Popover, List, ListItem, ListItemText, ListItemIcon, DialogTitle , makeStyles, useTheme} from '@material-ui/core';
import {trophyIcons, trophyDescriptions} from "../../../utils/helpers";
import guid from '../../../utils/guid';
import t from '../../../languages/pl';

const trophyIconsByRank = trophyIcons.slice().reverse();
const trophyDescriptionsByRank = trophyDescriptions.slice().reverse();

const useStyles = makeStyles(theme => ({
    image: {
        height: 20,
        width: 20,
    },
    text: {
        marginLeft: theme.spacing(1)
    },
    icon: {
        minWidth: 20,
        minHeight: 20,
        margin: theme.spacing(0.5)
    },
}));

const TrophyLegendPopover = props => {
    const { anchorEl, onClose } = props;
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const theme = useTheme();
    const classes = useStyles(theme);

    const printContent = () => {
        return trophyIconsByRank.map((trophyIcon, index) => {
            return (
                <ListItem
                    key={guid()}>
                    <ListItemIcon className={classes.icon} style={{ marginLeft: 0 }}>
                        <img src={trophyIcon} className={classes.image} />
                    </ListItemIcon>
                    <ListItemText className={classes.text}>
                        {trophyDescriptionsByRank[index]}
                    </ListItemText>
                </ListItem>
            );
        });
    };

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
        >
            <DialogTitle> {t.guidelines} </DialogTitle>
            <List>
                {printContent()}
            </List>
        </Popover>
    );
};

TrophyLegendPopover.propTypes = {
    classes: PropTypes.object,
    anchorEl: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func
};

export default (TrophyLegendPopover);
